import { FontSizes, FontWeights, getTheme, IStyle } from "@fluentui/react";

export function getBwjUploadStyles(disabled: boolean) {
    const theme = getTheme();

    const uploadField: IStyle = {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
        position: 'relative',
    };
  
  const label: IStyle = {
    fontSize: FontSizes.size14,
    fontWeight: FontWeights.bold,
    color: theme.palette.neutralPrimary,
    margin: 0,
    padding: '5px 0',
    boxSizing: 'border-box',
    display: 'block',
    overflowWrap: 'break-word',
  };
  
  const label_required: IStyle = {
    '&::after': {
      content: '" *"',
      color: theme.semanticColors.errorIcon,
      paddingRight: '12px',
    },
  };
  
  const dropZone: IStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 28,
    fontSize: FontSizes.size16,
    color: !disabled ? theme.semanticColors.inputPlaceholderText : theme.semanticColors.disabledText,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: !disabled ? theme.palette.neutralSecondary : theme.semanticColors.disabledBorder,
    borderRadius: 2,
    '&:hover': !disabled ? {
      borderColor: theme.palette.neutralPrimary,
    } : undefined,
    '&:focus-within': !disabled? {
      borderColor: theme.palette.themePrimary,
      borderWidth: 2,
    } : undefined,
    backgroundColor: !disabled ? 'white' : theme.semanticColors.disabledBackground,
  };
  
  const dropZone_hot: IStyle = {
    borderColor: theme.palette.themePrimary,
    borderWidth: 2,
    '&:hover': {
      borderColor: theme.palette.themePrimary,
    },
  };
  
  const dropZone_invalid: IStyle = {
    borderColor: theme.semanticColors.errorText,
    '&:hover': {
      borderColor: theme.semanticColors.errorIcon,
    },
  };
  
  const uploadIcon: IStyle = {
    fontSize: FontSizes.xxLargePlus,
  };
  
  const dropZonePrompt: IStyle = {
    margin: 0,
    padding: 0,
    paddingTop: 10,
  };
  
  const fileSelectPrompt_hot: IStyle = {
    color: theme.palette.themePrimary,
    textDecoration: 'underline',
  };
  
  const fileSelectPrompt: IStyle = {
    border: 'none',
    backgroundColor: 'transparent',
    cursor: !disabled ? 'pointer' : 'default',
    fontSize: 'inherit',
    color: !disabled ? theme.palette.themeSecondary : theme.semanticColors.disabledText,
    display: 'inline',
    fontFamily: 'inherit',
    padding: 0,
    margin: 0,
    '&:hover': !disabled ? fileSelectPrompt_hot : undefined,
    '&:focus': !disabled ? fileSelectPrompt_hot : undefined,
    '&:active': !disabled ? fileSelectPrompt_hot : undefined,
  };
  
  const fileSelectPromptLabel: IStyle = {
    cursor: 'inherit',
    fontSize: 'inherit',
    color: 'inherit',
    fontFamily: 'inherit',
    padding: 0,
    margin: 0,
    textDecoration: 'inherit',
  };

  return {
    label,
    label_required,
    uploadField,
    uploadIcon,
    dropZone,
    dropZone_hot,
    dropZone_invalid,
    dropZonePrompt,
    fileSelectPrompt,
    fileSelectPromptLabel,
  };
}